import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import router from './router'
import {getLoginRouter} from './router/loginRoute'
import Vuex from 'vuex'
import store from './store'
import vueEsign from 'vue-esign'
import {getProfiles} from "@/common/staticdata/static-data-restapi.js"
import "./assets/font/font.css"
import ElementUI from 'element-ui';
import "bootstrap-icons/font/bootstrap-icons.css";
import 'element-ui/lib/theme-chalk/index.css';

import './assets/css/reset.css'
import './assets/css/icon/bootstrap.css'
import './assets/css/debug.css'
import './assets/css/btn-style.css'

import './common/permission/permission.js'
import './common/permission/disabledPermi.js'
import './common/validate/validate.js'
import './common/upload/fileupload.js'
import './common/editor/editor.js'
import './common/video/videocomponent.js'
import './common/excel/excel.js'
import './common/util/directives.js'
// import fackClickOutSide from './common/mixins/fackClickOutSide.js'

import {ellipsis} from "./common/util/string.util"


Vue.config.productionTip = false;
Vue.use(Router);
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(vueEsign);
Vue.filter('ellipsis', ellipsis);

getProfiles(getProfile()).then((res) => {
  let entList = res.data;
  for (let data of entList) {
    let loginRoute = getLoginRouter();
    loginRoute.name = "login_" + data.tenantId;
    loginRoute.path = "/login_" + data.tenantId;
    loginRoute.meta.shortName = data.shortName;
    if(data.hasOwnProperty("longName")){
      loginRoute.meta.longName = data.longName;
    }
    if(data.hasOwnProperty("loginLogoType")){
      loginRoute.meta.loginLogoType = data.loginLogoType;
    }
    if(data.hasOwnProperty("loginCodeType")){
      loginRoute.meta.loginCodeType = data.loginCodeType;
    }
    loginRoute.meta.tenantId = data.tenantId;
    loginRoute.meta.Android = data.Android;
    loginRoute.meta.iOS = data.iOS;
    router.addRoute(loginRoute);
  }

  new Vue({
    el: '#app',
    router,
    // mixins:[fackClickOutSide],
    render: h => h(App),
    store: store
  });

});





// WEBPACK FOOTER //
// ./src/main.js